module.exports = __webpack_public_path__ + "img/d-10.89172e92.png";